import React, { Fragment } from 'react'
import apiService from '../../services/api'
import { CollapsibleSection } from '../UI/CollapsibleSection/CollapsibleSection'
import { MenuTable } from '../Tables/MenuTable'
import { formatInteger } from '../../utils/formatting'

interface IChainMenuCardProps {
  chainId?: number
}

export function ChainMenuSection(props: IChainMenuCardProps) {
  const api = apiService()
  const { data: menu, isLoading: isLoadingMenu } = api.useGetChainMenuList(
    props.chainId
  )

  if (isLoadingMenu || !menu) {
    return null
  }

  return (
    <CollapsibleSection
      forceClose={menu.length < 1}
      summary={
        <>
          Menu{' '}
          <span className={'font-thin'}>({formatInteger(menu.length)})</span>
        </>
      }
    >
      <MenuTable
        chainId={props.chainId}
        showLoadingState={false}
        showEmptyState={false}
        className="w-full"
      />
    </CollapsibleSection>
  )
}
